import React from 'react';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import Button from '../components/Button';
import ModeToggle from '../components/ModeToggle';
import Tooltip from '../components/Tooltip';
import { BEACON_POST_MODE_TOGGLE } from '../constants/onboarding';
import { EditorActions } from '../editor/editorSlice';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';

interface PostModeToggleProps {
  mobile?: boolean;
}

const PostModeToggle = ({ mobile }: PostModeToggleProps) => {
  const isEditable = useAppSelector((state) => state.editor.editable);
  const isLocked = useAppSelector(
    (state) => state.session.organization.isLocked,
  );
  const readOnly = useAppSelector((state) => state.editor.readOnly);

  const dispatch = useAppDispatch();

  const toggleMode = () => {
    dispatch(EditorActions.readOnly(!readOnly));
  };

  const isDisabled = !isEditable || isLocked;

  const inner = mobile ? (
    <Button variant="secondary" onClick={toggleMode} disabled={isDisabled}>
      {readOnly ? 'Edit' : 'Done'}
    </Button>
  ) : (
    <TutorialBeacon id={BEACON_POST_MODE_TOGGLE} placement="bottom-start">
      <div>
        <ModeToggle
          left={readOnly ? 'Edit' : 'Editing'}
          right={readOnly ? 'Reading' : 'Read'}
          leftActive={!readOnly}
          disabled={!!isDisabled}
          onToggle={toggleMode}
        />
      </div>
    </TutorialBeacon>
  );

  return isDisabled ? (
    <Tooltip
      enabledForSmallSize
      placement="bottom"
      content={'This post is read-only\nand cannot be edited'}
    >
      {inner}
    </Tooltip>
  ) : (
    inner
  );
};

export default PostModeToggle;
